"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMarkingFailed = exports.createMarkingSuccess = exports.createMarkingRequest = void 0;
const Actions = require("../../actionTypes/tasks/crud");
const createMarkingRequest = (fileId, marking) => ({
    type: Actions.CREATE_MARKING_REQUEST,
    payload: {
        fileId,
        marking
    }
});
exports.createMarkingRequest = createMarkingRequest;
const createMarkingSuccess = (marking) => ({
    type: Actions.CREATE_MARKING_SUCCESS,
    payload: marking
});
exports.createMarkingSuccess = createMarkingSuccess;
const createMarkingFailed = () => ({
    type: Actions.CREATE_MARKING_FAILED
});
exports.createMarkingFailed = createMarkingFailed;
//# sourceMappingURL=crud.js.map